import React from 'react';
import DatePicker, {registerLocale} from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import et from 'date-fns/locale/et';
import {format} from "date-fns";

registerLocale('et', et)

//@ts-ignore
const DateInput: React.FC<any> = ({placeholder, value, name, onChange, onBlur}: any) => {

    const parseDate = (dateString: string): Date | null => {
        if (!dateString) {
            return null;
        }
        const parts = dateString.split('.');
        if (parts.length === 3) {
            const day = parseInt(parts[0], 10);
            const month = parseInt(parts[1], 10) - 1;
            const year = parseInt(parts[2], 10);

            if (!isNaN(day) && !isNaN(month) && !isNaN(year)) {
                const date = new Date(year, month, day);
                if (!isNaN(date.getTime())) {
                    return date;
                }
            }
        }
        return null;
    };

    const handleDateChange = (selectedDate: Date) => {

        const formattedDate = format(selectedDate, 'dd.MM.yyyy');

        const event = {
            target: {
                name: name,
                value: formattedDate,
            },
        };

        onChange(event);

    };

    return (
        <div>
            <DatePicker
                selected={parseDate(value)}
                onChange={handleDateChange}
                dateFormat={'dd.MM.yyyy'}
                className={'date hasDate'}
                placeholderText={placeholder}
                locale="et"
            />
        </div>
    );
};

export default DateInput;